import { useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useCatalog } from '../context/CatalogContext';
import { ProductRow } from '../components/ProductCard';
import type { ProductType } from '../lib/types';

const TYPE_FILTERS: { key: ProductType | 'all'; label: string }[] = [
  { key: 'all', label: 'All' },
  { key: 'notes', label: 'Notes' },
  { key: 'pyq', label: 'PYQs' },
  { key: 'quiz', label: 'Quizzes' },
  { key: 'test-series', label: 'Test Series' },
];

export function Store() {
  const { products, exams, loading } = useCatalog();
  const [params] = useSearchParams();
  const [query, setQuery] = useState('');
  const [type, setType] = useState<ProductType | 'all'>('all');
  const [exam, setExam] = useState<string>(params.get('exam') || 'all');

  const results = useMemo(() => {
    const q = query.trim().toLowerCase();
    return products.filter((p) => {
      if (type !== 'all' && p.type !== type) return false;
      if (exam !== 'all' && p.exam !== exam) return false;
      if (q && ![p.title, p.subject, p.author, ...(p.tags || [])].join(' ').toLowerCase().includes(q)) return false;
      return true;
    });
  }, [products, query, type, exam]);

  return (
    <div style={{ paddingTop: 20 }}>
      <h1 style={{ fontSize: 24, fontWeight: 900, marginBottom: 14 }}>Store</h1>
      <input className="input" placeholder="Search notes, PYQs, tests…" value={query} onChange={(e) => setQuery(e.target.value)} />

      <div className="row gap8 wrap" style={{ marginTop: 14 }}>
        {TYPE_FILTERS.map((f) => (
          <button key={f.key} className={`chip ${type === f.key ? 'active' : ''}`} onClick={() => setType(f.key)}>
            {f.label}
          </button>
        ))}
      </div>
      <div className="row gap8 wrap" style={{ marginTop: 10 }}>
        <button className={`chip ${exam === 'all' ? 'active' : ''}`} onClick={() => setExam('all')}>📚 All exams</button>
        {exams.map((e) => (
          <button key={e.id} className={`chip ${exam === e.id ? 'active' : ''}`} onClick={() => setExam(e.id)}>
            {e.emoji} {e.name}
          </button>
        ))}
      </div>

      <div style={{ marginTop: 20 }}>
        <div className="muted" style={{ fontWeight: 700, marginBottom: 12 }}>
          {loading ? 'Loading…' : `${results.length} ${results.length === 1 ? 'result' : 'results'}`}
        </div>
        {results.map((p) => (
          <ProductRow key={p.id} product={p} />
        ))}
        {!loading && results.length === 0 && (
          <div className="col center" style={{ padding: 40, gap: 6 }}>
            <div style={{ fontSize: 42 }}>🔍</div>
            <div style={{ fontWeight: 800 }}>No results found</div>
            <div className="muted">Try a different search or filter.</div>
          </div>
        )}
      </div>
    </div>
  );
}
